import EndPointTypes from 'interfaces/EndPointTypes';
import { AuthProtect } from '@/common/enum';

export const putDashboardSettings = (data: Partial<ISettings>): EndPointTypes => ({
  authorization: AuthProtect.REQUIRED,
  method: 'PUT',
  url: 'api/settings/dashboard',
  data,
});
